import { language as lan_registForm } from "./regist-form";
import { language as lan_thirdPartyRegist } from "./third-party-regist";

let language = {
    ...lan_thirdPartyRegist,
    ...lan_registForm,

    REGIST_CREATE_ACCOUNT_TEXT: "Create your free account to start selling today.",
    REGIST_SIGNUP_WITH_EMAIL_BTN: "Sign up with your email",
    REGIST_BACK_BTN: "Back",
    REGIST_ALREADY_HAVE_ACCOUNT_TEXT: "Already have an account?",
    REGIST_SIGNIN_LINK: "Sign In",
    REGIST_OTHER_REGISTRATION_TEXT: "Others Registration",

    "A114B001": "Please input 8 to 20 characters, including uppercase,lowercase,numbers and symbols",
    "A114B002": "Your 'confirm password' should be the same as your password",
};

export { language }